import { BasicProgramInformation } from '@app/catalog-common/data/http/dtos/basic-program-information';
import { BasicUserInformation } from '@app/security-common/data/http/dtos/basic-user-information';
import { Notification } from '@app/shared';
import { SpaDto } from '../http/dtos/project/spa.dto';

//NB: The registered name must match the class name the server broadcasts (SPAProjectCreatedNotification),
//    not this class's own name - NotificationFactory looks the payload's type string up in the registry.
@Notification({
  name: "SPAProjectCreatedNotification",
})


export class SPAProjectCreatedNotification {
    public projectId: string;
    public projectName: string;
    public projectSqlId: string;
    public thumbnailUrl: string | null;
    public cap: string | null;
    public spa: SpaDto | null;
    public program: BasicProgramInformation | null;
    public createdBy: BasicUserInformation;
}
